// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VeeValidate, { Validator } from 'vee-validate'
import VeeJa from 'vee-validate/dist/locale/ja'
import Buefy from 'buefy'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@/assets/css/style.scss'
import VueHead from 'vue-head'
import PortalVue from 'portal-vue'

// storage
import store from './store'

// style
Vue.config.productionTip = false
Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultToastDuration: 10000,
  defaultNotificationDuration: 10000,
  defaultNoticeQueue: false // 1枚ずつではなく、並べて表示する
})

// validation
Vue.use(VeeValidate)
Validator.localize('ja', VeeJa)

Vue.use(VueHead)
Vue.use(PortalVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js